import {SummonDataProperty} from 'src/tracker/model/property/summon/summon-data-property'

export const leviathanProperty = new SummonDataProperty(
  "b1d5d120-cbca-4cad-9b48-14f897a9a8ee",
  "Leviathan",
)
